var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPpt = function SvgPpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9DEE4",
    fillRule: "evenodd",
    d: "M16 0v14H0V0zM8 1a.5.5 0 0 0-.5.5v1H2v8h3.117l-1.046 1.742a.5.5 0 0 0 .857.516L6.283 10.5h3.434l1.355 2.258a.5.5 0 1 0 .856-.516L10.883 10.5H14v-8H8.5v-1A.5.5 0 0 0 8 1m5 2.5v6H3v-6z"
  })));
};
export default SvgPpt;